export default __webpack_public_path__ + "static/Nanoporetech-8f15fcd9487709e808e3b371f412fce8.png";